var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scroll-board-right"}},[_c('dv-border-box-6',[_c('div',{staticClass:"table-name",staticStyle:{"text-align":"center","padding-top":"8px"}},[_c('img',{attrs:{"src":require("./img/icon5.png")}}),_vm._v("最近完成订单\n    ")]),_c('dv-scroll-board',{staticStyle:{"margin-top":"-15px"},attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }